import { SVGProps } from 'react';

export default function HighwayExitSignIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" {...props}>
      <circle cx="15" cy="15" r="12" fill="#3F454D" />
      <path
        d="M19.7159 17.3815C19.7159 17.3815 19.7216 17.3701 19.7273 17.3701C19.7445 17.3414 19.756 17.307 19.7675 17.2783V17.2725C19.7675 17.2725 19.7732 17.2496 19.7732 17.2381L19.7904 17.1291L21.299 9.35095L21.3162 9.20181C21.3392 9.05267 21.2875 8.90927 21.19 8.81176C21.0753 8.70277 20.9319 8.65115 20.7942 8.67983L20.6967 8.69703L12.8957 10.2171L12.758 10.2401C12.6662 10.263 12.5974 10.3032 12.5286 10.372C12.3565 10.5441 12.3508 10.8309 12.5286 11.0087C12.5515 11.0316 12.5859 11.0488 12.6146 11.0661L12.6949 11.1119L15.4712 12.8213L8.67969 19.0565L10.9512 21.328L17.1863 14.5536V14.5421L18.8669 17.2783L18.9358 17.3758C18.9587 17.4102 18.9759 17.4446 19.0046 17.4733C19.1767 17.6454 19.4692 17.6454 19.6413 17.4733C19.67 17.4446 19.6929 17.416 19.7101 17.3873"
        fill="white"
      />
    </svg>
  );
}
